import { useState } from 'react';
import routes from 'js/core_pre_webpack/routes';
import { ResearchInterest } from './types';
import { fetchWithCsrf } from 'js/utils/fetch_with_csrf';
import { Aedu } from 'global';

// External interface for the useRis hook
type UseRisType = {
  // Used to follow/unfollow an RI
  followRi: (ri: ResearchInterest) => void;
  // List of RIs
  ris: ResearchInterest[];
  // It's necessary to expose this
  // so the top level Sidebar component that
  // makes the initial API call can set the
  // initial RIs
  setRis: (ris: ResearchInterest[]) => void;
};

// Used to manage state for research interests
// and call the API to follow/unfollow
export const useRis = (initialRis: ResearchInterest[] = []): UseRisType => {
  const [ris, setRis] = useState(initialRis);

  const followRi = async (riToToggle: ResearchInterest) => {
    const body = new URLSearchParams();
    body.append('tag_type', 'ResearchInterest');
    body.append('target_type', 'User');
    body.append('target_id', Aedu.User.current?.id);
    body.append('tag[id]', riToToggle.id.toString());

    // If currently following, we need to unfollow
    const route = riToToggle.following
      ? routes.remove_api_v0_taggings_path({ subdomain_param: 'api' })
      : routes.add_api_v0_taggings_path({ subdomain_param: 'api' });

    const res = await fetchWithCsrf(route, {
      body: body,
      credentials: 'include',
      method: 'POST',
    });
    if (res.ok) {
      setRis(
        ris.map((ri) =>
          ri.id === riToToggle.id ? { ...ri, following: !ri.following } : ri,
        ),
      );
    }
  };

  return { followRi, ris, setRis };
};
